import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'

import {createPinia } from 'pinia';

import router from './router/index.js';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

const pinia = createPinia();

createApp(App)
  .use(pinia)
  .use(router)
  .mount('#app')

